export enum PurchaseOrderStatusEnum {
  Draft = 'Draft',
  RequestForQuotation = 'Request for Quotation',
  PurchaseOrder = 'Purchase Order',
  Received = 'Received',
  PartiallyReceived = 'Partially Received',
  Cancelled = 'Cancelled',
}
